import { gaHelper } from '../app/containers/AnalyticsGoogleTag/gaHelper'
import './sass/api/api_all.scss'
import 'EgamingGameRunModule'
import 'Helpers/isMobile'

gaHelper.addInfo('pageview')
